
import Vue from 'vue';
import GlassButton from '@/components/base/GlassButton.vue';

/**
 * The "Filter" button that opens and closes a <filters-panel>. The host owns
 * whether the panel is open and passes it back as `expanded`; this only draws
 * the button and says it was clicked. It lights up while the panel is open or
 * any filter is applied, and counts the applied ones.
 */
export default Vue.extend({
	name: 'FilterToggleButton',
	props: {
		expanded: { type: Boolean, default: false },
		// How many filters are applied (not merely drafted in the open panel).
		activeCount: { type: Number, default: 0 },
		label: { type: String, default: 'Filter' },
	},
	computed: {
		lit (): boolean {
			return this.expanded || this.activeCount > 0;
		},
	},
	components: {
		GlassButton,
	},
});
